import VaccinatePage from "../components/Vaccinations";
function Vaccinations(){
return(
    <VaccinatePage/>
)
}
export default Vaccinations;